import { render } from "./CookiesPolicy.vue?vue&type=template&id=034ed5a8"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"

import "./CookiesPolicy.vue?vue&type=style&index=0&id=034ed5a8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__